import { t } from '@lingui/macro';

import { Actions, Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import Link from '../../links/Link';
import { JumpSettings as JumpSettingsIcon } from '../../icon/Icons';
import { useIsAdminUser } from '../../../stores/SessionStore';
import { HypervisorFilter, hypervisorFilterId, TimeRangeFilter, useHypervisor } from '../../filters';
import { useSummarizedFilterStateById } from '../../../stores/FilterStateStore';
import { LAYOUT_WIDTH } from '../../page-framework/panel-container/PanelContainer';

import {
    HypervisorStatusPanel,
    HypervisorCpuUtilizationPanel,
    HypervisorMemoryUtilizationPanel,
    HypervisorDiskLatencyPanel,
    HypervisorNetworkThroughputPanel,
    HypervisorVmStatusBreakoutPanel,
    HypervisorVmCpuBreakdownPanel,
    HypervisorVmMemoryBreakdownPanel,
    HypervisorSyslogPanel,
    HypervisorPropertiesPanel,
} from '../../panels';

export const pageId = 'vmware-host-detail';

export default function HypervisorDetailPage() {
    const hypervisor = useHypervisor();
    const [isAdminUser] = useIsAdminUser();
    const [summarized] = useSummarizedFilterStateById(hypervisorFilterId);
    const title = summarized?.value;

    return (
        <Page id={pageId}>
            <PageHeader
                title={title}
                titleActions={
                    hypervisor &&
                    !hypervisor.deleted &&
                    isAdminUser && (
                        <Actions>
                            <Link
                                to={`/admin/virtual-infrastructure/${hypervisor?.uuid}`}
                                title={t`Edit hypervisor configuration`}
                            >
                                <JumpSettingsIcon fontSize="small" />
                            </Link>
                        </Actions>
                    )
                }
            >
                <FilterContainer>
                    <TimeRangeFilter required />
                    <HypervisorFilter required />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <HypervisorStatusPanel width={LAYOUT_WIDTH.FULL} title={t`Status`} />
                <HypervisorCpuUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`CPU Utilization`} />
                <HypervisorMemoryUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`Memory Utilization`} />
                <HypervisorDiskLatencyPanel width={LAYOUT_WIDTH.HALF} title={t`Disk Latency (Max)`} />
                <HypervisorNetworkThroughputPanel width={LAYOUT_WIDTH.HALF} title={t`Network I/O`} />
                <HypervisorVmStatusBreakoutPanel width={LAYOUT_WIDTH.FULL} title={t`Virtual Machines Status`} />
                <HypervisorVmCpuBreakdownPanel width={LAYOUT_WIDTH.HALF} title={t`CPU Usage: Top 5 VMs`} />
                <HypervisorVmMemoryBreakdownPanel width={LAYOUT_WIDTH.HALF} title={t`Memory Usage: Top 5 VMs`} />
                <HypervisorSyslogPanel width={LAYOUT_WIDTH.FULL} title={t`Syslog Events`} />
                <HypervisorPropertiesPanel width={LAYOUT_WIDTH.FULL} title={t`Properties`} />
            </PanelContainer>
        </Page>
    );
}
